import { render, staticRenderFns } from "./configForm.vue?vue&type=template&id=451a03e3&scoped=true"
import script from "./configForm.vue?vue&type=script&lang=js"
export * from "./configForm.vue?vue&type=script&lang=js"
import style0 from "./configForm.vue?vue&type=style&index=0&id=451a03e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a03e3",
  null
  
)

export default component.exports